const BRASIL = "BR";
const CEP_LENGTH = 8;
const UF_FORMAT = /^[A-Za-z]{2}$/;

const REQUIRED_ADDRESS_FIELDS = [
  "address_zipcode",
  "address_street",
  "address_number",
  "address_neighborhood",
  "address_city",
  "address_state",
];

export const ADDRESS_FIELDS = [...REQUIRED_ADDRESS_FIELDS, "address_complement"];

export const shouldAskAddress = (values, checkout) =>
  !!checkout?.ask_address &&
  values?.country === BRASIL &&
  values?.address_required === true;

export const validateAddress = (values, checkout, t) => {
  const errors = {};

  if (!shouldAskAddress(values, checkout)) {
    return errors;
  }

  REQUIRED_ADDRESS_FIELDS.forEach(field => {
    if (!values?.[field]?.toString().trim()) {
      errors[field] = t("campo-obrigatorio");
    }
  });

  if (
    !errors.address_zipcode &&
    values.address_zipcode.replace(/\D/g, "").length !== CEP_LENGTH
  ) {
    errors.address_zipcode = t("cep-invalido");
  }

  if (!errors.address_state && !UF_FORMAT.test(values.address_state.trim())) {
    errors.address_state = t("uf-invalida");
  }

  return errors;
};

// The API only needs the address when the fields are shown; address_required is UI state.
export const withoutHiddenAddress = (values, checkout) => {
  const { address_required, ...payload } = values;

  if (shouldAskAddress(values, checkout)) {
    return payload;
  }

  ADDRESS_FIELDS.forEach(field => delete payload[field]);

  return payload;
};
